module.exports = __webpack_public_path__ + "static/media/left-arrow-icon.75e4f344.svg";